<style>
  .menu_item{
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 0px;
    display: inline-block;
    cursor: pointer;
    color: #fff;
  }
  .menu_options_sub{
    display: none;
    width: 100%;
    height: auto;
    position: absolute;
    top: 55px;
    background-image: linear-gradient(#fff,#D3D3D3);
    color:#000000;
  }
  .mlink a{
    text-decoration: none;
    color:#000000;
  }
  .mlink{
    padding-top: 4px;
    padding-bottom: 6px;
    border-bottom: 1px dotted #bdbdbd;
  }
  .active{
    color:#4b8cbb!important;
  }
  tr:hover{
    background-color: transparent;
  }
  .topheadv1{
    padding-bottom: 5px;
    cursor: pointer;
    font-size: 14px;
  }
  .menu_options_mn{
    height: 100%;
    vertical-align: middle;
    line-height: 3;
    margin-left: 45px;
  }
  .menu_data{
    text-align: left;
    height: 100%;
    border: 1px solid #bdbdbd;
    font-family: Roboto, Arial, sans-serif;
    color: #424242;
    font-size: 13px;
    font-weight: 500;
  }
.table {
  width: 100%;
  height:100%;
  max-width: 100%;
  margin-bottom: 1rem;
  background-color: transparent;
}
.table td{
  border: none;
}
.dropdown-toggle::after{
  border-top: 0.3em solid #fff;
}
.app-header.navbar .dropdown-menu{
  top: 42px;
}
.app-header.navbar .navbar-brand,.app-header.navbar{
  background-color: #20a8d8;
}
.navbar-nav .nav-link.active,.navbar .navbar-nav .active.dropdown-toggle:hover,{
  color: #fff!important;
}
.dropdown-toggle:after {
  display: none !important;
}
.custom-caret{
  font-size: 18px;
  padding: 5px !important;
  color: #fff
}
/* .onHover:hover{
  border: 1px solid #fff !important;
} */
.onHover .dropdown-menu.dropdown-menu-right{
  top: -10px !important;
}
.sidebar-fixed .sidebar,
.sidebar .sidebar-nav,
.sidebar .nav {
  width: 245px;
}
.sidebar-fixed .main,
.sidebar-fixed .app-footer {
  margin-left: 245px;
}
.navbar ul.navbar-nav li{
  border-bottom: none;
}
.app-header.navbar .navbar-toggler {
  color: #fff;
  border: 1px solid #fff;
  border-radius: 8px;
  margin-left: 80px;
}
.breadcrumb ul li{
  border-bottom: none;
}
.onHover .ui.dropdown:not(.button)>.default.text{
  color: #fff;

}
.onHover .ui.search.dropdown>input.search{
  background: #20a8d8 !important;
  border: 1px solid #fff !important;
  height: 35px;
  color: #fff
}

/* .onHover .ui.fluid.search.selection.dropdown.form-control:hover{
  border: 1px solid #fff !important;
} */

.onHover .ui.selection.dropdown>.dropdown.icon{
  color:#fff;
}
.notifyLableCSS{
  text-decoration: underline;
  background-blend-mode: multiply;
  text-shadow: 0 0 black;
}
.NotifyIconCSS{
  /* display: block; */
  /* padding-left: 3px;
  padding-top: 3px;
  transform: rotate(15deg); */
  font-size: 18px;
  cursor: pointer;
  color: gold
}
.NotifySpanCSS{
  margin-right:30px;
  font-size: 15px;
  cursor: pointer;
  color: whitesmoke
}
.fa-stack[data-count]:after{
  position:absolute;
  right:0%;
  top:1%;
  content: attr(data-count);
  font-size:50%;
  padding:.6em;
  border-radius:10px;
  line-height:.75em;
  color: white;
  background:rgba(255,0,0,.85);
  text-align:center;
  min-width:2em;
  font-weight:bold;
}
</style>
<template>
<header class="app-header navbar">
  <b-link class="navbar-brand" to="Dashboard"></b-link>
  <button class="navbar-toggler sidebar-toggler d-md-down-none" type="button" @click="sidebarMinimize">&#9776;</button>
 <!--  <b-nav is-nav-bar class="d-md-down-none">
    <b-nav-item class="px-3">Dashboard</b-nav-item>
    <b-nav-item class="px-3">Users</b-nav-item>
    <b-nav-item class="px-3">Settings</b-nav-item>
  </b-nav> -->
  <b-nav is-nav-bar class="ml-auto" style="margin-right:1%;">
  <!--   <b-nav-item class="d-md-down-none">
      <i class="icon-bell"></i><span class="badge badge-pill badge-danger">5</span>
    </b-nav-item> -->
    <!-- <b-nav-item class="d-md-down-none">
      <i class="icon-list"></i>
    </b-nav-item> -->
 <!--    <b-nav-item class="d-md-down-none">
      <i class="icon-location-pin"></i>
    </b-nav-item> -->
    <b-nav-item-dropdown class="custom-dropdown" style="left:16px;" v-if="isMisrouteEnabled">
      <template slot="button-content">
        <span v-if="notificationCount == 0" class="fa-stack NotifySpanCSS" title="Notifications" @click="checkIsNotificationOpen()">
          <i class="fa fa-bell fa-stack-1x fa-inverse NotifyIconCSS"></i>
        </span>
        <span v-else class="fa-stack NotifySpanCSS" title="Notifications" @click="checkIsNotificationOpen()" :data-count="notificationCount">
          <!-- <i class="fa fa-circle fa-stack-2x"></i> -->
          <i class="fa fa-bell fa-stack-1x fa-inverse NotifyIconCSS"></i>
        </span>
      </template>
      <template v-if="isNotify">
        <div style="background-color: lightgrey;">
          &nbsp&nbsp<label for="notifications" class="notifyLableCSS">Notifications</label>
        </div>
        <b-dropdown-item v-for="item in notificationsList" v-bind:key="item.value" @click="goToNotificationUrl(item)" style="padding-left: 10px;color: orangered">{{item.text}}</b-dropdown-item>
      </template>
    </b-nav-item-dropdown>
    <b-nav-item-dropdown right style="width: 135px;padding:5px;" class="onHover">
      <template slot="button-content">
        <!-- <span style="color:#fff"> CHANGE HUB <i class="fa fa-caret-down custom-caret"></i></span> -->
        <basic-select style="width:135px;background-color: #20a8d8;" :options="hubaccessObjArray" :selected-option="hubObj" name="ChangeHub" placeholder="CHANGE HUB" @select="changeHubTodefaultHub" v-bind:class="{'form-control': true}">
        </basic-select>
        <!-- <i class="fa fa-caret-down" style="color:#000;font-size:20px;padding-left: 5px;"></i> -->
      </template>
      <!-- <basic-select :options="hubaccessObjArray" :selected-option="hubObj" v-model="HubID" name="SR" placeholder="Select SR" @select="changeHubTodefaultHub" v-validate="{required:true}" v-bind:class="{'form-control': true}">
      </basic-select> -->
      <!-- <b-dropdown-item v-for="hub in hubaccess" v-bind:key="hub.HubID" @click="changeHubTodefaultHub(hub.HubID)" > {{hub.HubName}}</b-dropdown-item> -->

    </b-nav-item-dropdown>
    <b-nav-item-dropdown class="custom-dropdown">
      <template slot="button-content">
        <span style="color:#fff" class="dropdown-toggle"> <i class="fa fa-map-marker" style="font-size:22px;color:red;padding-left:10px"></i> {{currentHubName}} </span>
      </template>
    </b-nav-item-dropdown>
    <b-nav-item-dropdown right>
      <template slot="button-content">
          <img src="static/img/avatars/default-img.png" class="img-avatar" alt="admin@bootstrapmaster.com">
          <span class="d-md-down-none" style="color: #fff !important">{{username}}<i class="fa fa-caret-down custom-caret"></i></span>
        </template>
      <!--<b-dropdown-item @click="editProfile()"><i class="fa fa-user"></i> Profile</b-dropdown-item>
      <b-dropdown-item @click="changepassword"><i class="fa fa-sign-out"></i> Change Password</b-dropdown-item>-->
      <b-dropdown-item @click="logout"><i class="fa fa-lock"></i> Logout</b-dropdown-item>
    </b-nav-item-dropdown>
  </b-nav>

</header>
</template>
<script>
import CryptoJS from 'crypto-js';
import axios from 'axios'
import apiUrl from '../constants'
import {
  BasicSelect
} from 'vue-search-select';
import keycloak from '../../src/common/Keycloak';

export default {
  name: 'header',
  components: {
    BasicSelect
  },
  data() {
    return {
      username: '',
      usertype: '',
      logindata: [],
      navItem:[],
      userid: '',
      hubaccess : [],
      currentHub: '',
      currentHubName: '',
      hubaccessObjArray:[],
      hubObj: { value: "",text: ""},
      IsRVPPaperless: '',
      inputHub: {},
      notificationCount: 0,
      notificationsList: [],
      isNotify: false,
      isMisrouteEnabled: false,
      notificationData: null,
      userDataKey : '',
      IsRSC:'',
      // CenterType:''
    }
  },
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    var bytes  = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail =JSON.parse(plaintext);
    this.username = userdetail.username;
    this.userid = userdetail.userid;
    //console.log('this.userid',userdetail);
    this.loadAllHubAccessList();

    this.currentHub = userdetail.hubdetails[0];
    this.getConfigSettings();
    this.getHubConfigSettings();
    let notificationIntervalTime = userdetail.notificationIntervalTime ? userdetail.notificationIntervalTime: 1800000;
    //console.log("notificationIntervalTime in milliseconds::",notificationIntervalTime);

    this.isMisrouteEnabled = await this.getMisrouteEnabledFlag(this.currentHub);
    if(this.isMisrouteEnabled){
      this.getNotifications();
      // Set up interval to fetch notification count every few minutes
      this.notificationInterval = setInterval(() => {
        this.getNotifications();
      }, notificationIntervalTime); // Fetch every notificationIntervalTimes sec (adjust as needed)
    }

//     this.$nextTick(() => {
//       $(document).ready(function(){
//       $(".menu_options_mn").on("mouseover",function(){
//         $(".menu_options_sub").slideDown("slow");
//       });
//       $(".menu_options_sub").on("mouseleave", function(){
//         $(this).slideUp("slow");
//       });
//       $("a").click(function(){
//    $("a.active").removeClass("active");
//    $(this).addClass("active");
// });
//     });
//       })
    this.$nextTick(() => {
      // $(".nav-dropdown-parent").click(function(e){
      //   let checkflag = $(".nav-dropdown-parent").hasClass("open");
      //    if(checkflag == false) {
      //      $(".nav-dropdown-parent").removeClass("open");
      //    } else {
      //      $(".nav-dropdown-parent").removeClass("open");
      //      $(this).addClass("open");
      //    }
      // });
    })
  },
  beforeDestroy() {
    // Clear the interval when the component is destroyed
    clearInterval(this.notificationInterval);
  },
  methods: {
    checkIsNotificationOpen(){
      this.isNotify = true;
    },

    getMisrouteEnabledFlag(hubid){
      return new Promise( (resolve, reject) => {
        axios.post(apiUrl.api_url + 'misroute/general/getmisroutehubflag', {"hubId":hubid})
        .then((response) => {
          if(response.data.code == 200){
            let flag = response.data.data.misrouteEnabledFlagDel || response.data.data.misrouteEnabledFlagRvp || response.data.data.RTODTOmisrouteEnabledFlag;
            return resolve(flag);
          }
          else{
            return resolve(false);
          }
        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
      })
    },

    getNotifications(){
      axios.post(apiUrl.api_url + 'expose/general/get/notificationcount', {
        "hubid": this.currentHub
      })
      .then((response) => {
        if(response.data.code===200){
          this.notificationData = response.data.data;
          let notificationArrayList = this.getNotificationInfo(this.notificationData);
          if(notificationArrayList.length > 0){
            this.notificationsList = notificationArrayList;
            this.notificationCount = this.notificationsList.length;
          }
          else{
            this.notificationsList = [{
              value: 0,
              text: "No more notifications pending",
            }];
            this.notificationCount = 0;
          }
        }
        else{
          this.notificationsList = [{}];
          this.notificationCount = 0;
          this.$alertify.error('Failed to fetch notifications.');
        }
      })
      .catch((httpException) => {
        console.error('exception is:::::::::', httpException)
      })
    },

    getNotificationInfo(notifications){
      let infoArrayList = [];
      for (const key in notifications) {
        if (notifications.hasOwnProperty(key)) {
          let Key = key;
          let count = notifications[key]; //Value
          if(count > 0){
            let alertMsg = "[Action Required] : ";
            let keyInfo = this.getKeyURLAndMsgText(Key,count);
            let infoObj = {
              value: Key,
              text: alertMsg + count + " " + keyInfo.KeyMsgText,
              url: keyInfo.KeyURL
            }
            infoArrayList.push(infoObj)
          }
        }
      }
      return(infoArrayList);
    },

    getKeyURLAndMsgText(Key,count){
      let KeyInfoObj = {};
      if(Key == 'misrouteSVCNotifications'){
        KeyInfoObj.KeyURL = "/MisrouteRequestCheckerSVC";
        let notificationText = count > 1 ? "Misroute Requests pending" : "Misroute Request pending";
        KeyInfoObj.KeyMsgText = notificationText
      }
      else if(Key == 'others'){
        KeyInfoObj.KeyURL = "/dashboard";
        let notificationText = count > 1 ? "Requests pending" : "Request pending";
        KeyInfoObj.KeyMsgText = notificationText
      }
      return(KeyInfoObj);
    },

    goToNotificationUrl(obj){
      this.notificationId = obj.value;
      this.$router.push(obj.url)
    },

    loadAllHubAccessList() {
      let apiendpoint = 'external/getHubListaccessForUser';
      if (keycloak.enableKavach) {
        apiendpoint = 'user/migration/getaccesshublist';
      }
      axios.post(apiUrl.api_url + apiendpoint, {
        "userid":this.userid.toString()
      })
        .then((response) => {
            if(response.data.code===200){
              this.hubaccessObjArray = [];
              this.hubaccess = response.data.data.hubaccess;
              //console.log('this.hubaccess',this.hubaccess);
              for (var i = 0; i < this.hubaccess.length; i++) {
                this.hubaccessObjArray.push({
                  value: this.hubaccess[i].HubID,
                  text: this.hubaccess[i].HubName
                })
              }
              //console.log('this.hubaccessObjArray',this.hubaccessObjArray);

              let getcurrenthubobj = this.hubaccess.find(hubs => hubs.HubID == this.currentHub );
              this.currentHubName = getcurrenthubobj.HubName;

              let setusersEncruptHubList = CryptoJS.AES.encrypt(JSON.stringify(this.hubaccessObjArray), this.userDataKey);
              window.localStorage.setItem('hubaccesslist', setusersEncruptHubList);

              let setusersEncruptAllHubList = CryptoJS.AES.encrypt(JSON.stringify(this.hubaccess), this.userDataKey);
              window.localStorage.setItem('allhubaccesslist', setusersEncruptAllHubList);
            }
            else {
              this.$alertify.error(response.data.message);
            }
        })
        .catch((httpException) => {
            //this.$alertify.error("Hub list not loaded");
            console.error('exception is:::::::::', httpException)
        })
    },
    changeHubTodefaultHub(obj) {
      //console.log('getHubId',obj);
      let getHubId = obj.value
      let changeHubApiEndpoint = 'external/UpdateCurrentHub';
      if (keycloak.enableKavach) {
        changeHubApiEndpoint = 'user/migration/changecurrenthub';
      }
      axios.post(apiUrl.api_url + changeHubApiEndpoint, {
        "userid":this.userid,
        "currentHub": getHubId
      })
        .then((response,request) => {
            if(response.data.code===200){

              let getuserdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
              let getbytes  = CryptoJS.AES.decrypt(getuserdetailEncrypt.toString(), this.userDataKey);
              let getplaintext = getbytes.toString(CryptoJS.enc.Utf8);
              let userdetail =JSON.parse(getplaintext);
              userdetail.hubdetails[0] = getHubId;
              this.currentHub = getHubId;
              let setusersEncrupt = CryptoJS.AES.encrypt(JSON.stringify(userdetail), this.userDataKey);
              window.localStorage.setItem('lmaccessuserdata', setusersEncrupt);
              this.loadAllHubAccessList();
              this.getConfigSettings();
              this.getHubConfigSettings()
              this.$alertify.success("Hub changed successfully !");
              location.reload();
            }
            else {
              this.$alertify.error(response.data.message);
            }
        })
        .catch((httpException) => {
            this.$alertify.error("Hub not changed,please retry!");
            console.error('exception is:::::::::', httpException)
        })
    },
    getConfigSettings(){
      this.inputHub = {
        "Outsourceid":4,
        "hubid":this.currentHub
      }

      axios({
        method: 'POST',
        url: apiUrl.api_url + 'expose/hubservicecenter/getHubFlags',
        data: this.inputHub
      })
      .then(result => {
        if (result.data.data.code==200) {
          this.IsRVPPaperless = result.data.data.data.IsRVPPaperless;
          let setIsRVPPaperlessEncrupt = CryptoJS.AES.encrypt(JSON.stringify(this.IsRVPPaperless), this.userDataKey);
          window.localStorage.setItem('IsRVPPaperless', setIsRVPPaperlessEncrupt);

          this.IsRSC = result.data.data.data.IsRSC;
          let setIsRSCEncrupt = CryptoJS.AES.encrypt(JSON.stringify(this.IsRSC), this.userDataKey);
          window.localStorage.setItem('IsRSC', setIsRSCEncrupt);
        //  this.CenterType = result.data.data.data.CenterType;
          //let setCenterTypeEncrupt = CryptoJS.AES.encrypt(JSON.stringify(this.CenterType), this.userDataKey);
          //window.localStorage.setItem('CenterType', setCenterTypeEncrupt);
        }
      }, error => {
        console.error(error)
      })
    },
    getHubConfigSettings(){
      this.inputHub = {
        "hubids":[this.currentHub.toString()]
      }

      axios({
        method: 'POST',
        url: apiUrl.api_url + 'expose/hubservicecenter/hubarray/get',
        data: this.inputHub
      })
      .then(result => {
        if (result.data.data.code==200) {

          let locusroutingflag = result.data.data.data[0].ConfigSetting.isLocusRoutingEnable;
          let dayEndClosureflag = result.data.data.data[0].ConfigSetting.isDayendclosurefeature;
          // console.log("dayEndClosureflag:::::::::::",dayEndClosureflag);
          this.IsRVPPaperless = result.data.data.data.IsRVPPaperless;
          let setlocusroutingflagEncrypt = CryptoJS.AES.encrypt(JSON.stringify(locusroutingflag), "LocusKey");
          window.localStorage.setItem('IsLocusRouting', setlocusroutingflagEncrypt);
          if(dayEndClosureflag != 'undefined' && dayEndClosureflag != null){
            let setDayEndClosureflagEncrypt = CryptoJS.AES.encrypt(JSON.stringify(dayEndClosureflag), "DayEndClosureKey");
            window.localStorage.setItem('isDayendclosurefeature', setDayEndClosureflagEncrypt);
          }

          /**
            Using these flag in the lost module.
          */
          let centerType = result.data.data.data[0].CenterType;
          let soc = result.data.data.data[0].ConfigSetting.SOC;
          console.log('Centert TYPE and SOC', centerType)
          console.log('Centert TYPE and SOC', soc)
          let hubconfigDetails = {
            CenterType: centerType,
            SOC: soc
          }

          let sethubconfigs = CryptoJS.AES.encrypt(JSON.stringify(hubconfigDetails), this.userDataKey);
          window.localStorage.setItem('hubconfigs', sethubconfigs);

        }
      }, error => {
        console.error(error)
      })
    },
    sidebarToggle(e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },

    logout(e) {
      e.preventDefault()
       if (keycloak.enableKavach) {
        keycloak.logoutWithTokenId();
        //window.location.href = "https://stage-auth.xbees.in/realms/xpressbees/protocol/openid-connect/logout?client_id=lastmile-ui&post_logout_redirect_uri=http://localhost:8081/#/login"
       } else{
        localStorage.removeItem('lmaccesspermissiondata')
        localStorage.removeItem('lmaccessuserdata')
        localStorage.removeItem('userToken')
        localStorage.removeItem('isLoggedIn')
        localStorage.removeItem('IsRVPPaperless')
        localStorage.removeItem('IsRSC')
        localStorage.removeItem('isLoginAuthCheck')
        localStorage.removeItem('refreshToken')
        localStorage.removeItem('IsLocusRouting')
        localStorage.removeItem('isDayendclosurefeature')
        localStorage.removeItem('hubaccesslist')
        localStorage.removeItem('allhubaccesslist')
        localStorage.removeItem('lmUserToken')
        localStorage.removeItem('userUniqueKey')
        localStorage.removeItem('onepagerprintflag')
        localStorage.removeItem('hubconfigs')
        this.$router.push('/login')
       }
    },
     changepassword() {
        this.$router.push('/changepassword')
    },

    editProfile() {
      if (this.usertype == 'Merchant')
        this.$router.push('/merchantProfile')
      else if (this.usertype == 'Client')
        this.$router.push('/companyProfile')
      else
        this.$router.push('/')
    },
    // sidebarMinimize(e) {
    //   e.preventDefault()
    //   document.body.classList.toggle('sidebar-minimized')
    // },
    sidebarMinimize(e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle(e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle(e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    },
    itemlink(){
       $(".menu_options_sub").slideUp("slow");
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue?004def8e